module.exports = __webpack_public_path__ + "static/sales_flow-1e3a6822d7ea89c39c7f954c574747b8.png";